import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { ListChecks, Lock, CheckCircle2, X } from 'lucide-react';
import { sfx } from './rpSounds';

const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');
const k = (n) => (n >= 1000 && n % 1000 === 0 ? `${n / 1000}k` : fmt(n));

// Ícone no canto superior direito do card do baú → abre o card "Tarefas do dia" (baú extra). Dados do servidor.
export const RpTasksButton = ({ day }) => {
  const [open, setOpen] = useState(false);
  if (!day?.tasks?.length) return null;
  const done = day.tasks.filter((t) => t.done).length;
  const abrir = () => { sfx.click(); setOpen(true); };
  const fechar = () => { sfx.close(); setOpen(false); };
  return (
    <>
      <button onClick={abrir} data-testid="rp-tasks-btn" title="Tarefas diárias" aria-label="Tarefas diárias"
        className={`absolute right-2 top-2 z-10 flex items-center gap-1.5 rounded-full border px-3 py-1.5 backdrop-blur transition-transform active:scale-95 ${day.tasks_active
          ? 'rp-tasks-glow border-lime-400/80 bg-[#140a2e]/90 text-lime-200' : 'border-zinc-500/60 bg-black/60 text-zinc-300'}`}>
        <img src="/rp/chest.webp" alt="" className="h-5 w-5 object-contain drop-shadow-[0_0_6px_rgba(251,191,36,.8)]" />
        <span className="text-[10px] font-black uppercase tracking-wider">Tarefas diárias</span>
        <span data-testid="rp-tasks-badge" className={`rounded-full px-1.5 py-0.5 text-[9px] font-black text-black ${done ? 'bg-lime-300' : 'bg-amber-300'}`}>{done}/{day.tasks.length}</span>
        <style>{'@keyframes rp-tasks-glow { 0%,100% { box-shadow: 0 0 10px rgba(163,230,53,.45) } 50% { box-shadow: 0 0 22px rgba(163,230,53,.95), 0 0 34px rgba(217,70,239,.5) } } .rp-tasks-glow { animation: rp-tasks-glow 2.4s ease-in-out infinite }'}</style>
      </button>

      {open && createPortal(
        <div className="fixed inset-0 z-[96] flex items-end justify-center bg-black/80 p-4 backdrop-blur-sm sm:items-center" onClick={fechar} data-testid="rp-tasks-overlay">
          <div onClick={(e) => e.stopPropagation()} data-testid="rp-tasks"
            className="relative w-full max-w-md overflow-hidden rounded-3xl border-2 border-lime-400/60 bg-[#140a2e] p-5 shadow-[0_0_50px_rgba(163,230,53,.3)]"
            style={{ backgroundImage: 'linear-gradient(180deg, rgba(20,10,46,.9), rgba(20,10,46,.98)), url(/rp/bg.webp)', backgroundSize: 'cover' }}>
            <button onClick={fechar} data-testid="rp-tasks-close" aria-label="Fechar"
              className="absolute right-3 top-3 z-20 flex h-10 w-10 items-center justify-center rounded-full border border-fuchsia-400/60 bg-black/70 text-purple-50 transition-transform active:scale-95"><X className="h-5 w-5" /></button>
            <p className="flex items-center gap-1.5 pr-12 text-sm font-black uppercase tracking-[.2em] text-lime-300 drop-shadow-[0_0_8px_rgba(163,230,53,.8)]"><ListChecks className="h-4 w-4" /> Tarefas diárias</p>
            <p className="text-[10px] font-black uppercase tracking-[.3em] text-amber-300">baú extra todo dia</p>
            <p className="mt-1 text-[11px] text-purple-100/85">Cumpra a tarefa e ganhe baú <b>fora do limite diário</b>. Só pedidos com o pacote exato contam. Zera todo dia (horário de Brasília).</p>
            {!day.tasks_active && (
              <p className="mt-2 flex items-center gap-1.5 rounded-xl border border-zinc-500/50 bg-zinc-800/70 px-3 py-2 text-[11px] font-bold text-zinc-200" data-testid="rp-tasks-inactive">
                <Lock className="h-3.5 w-3.5" /> Sem presentes em estoque no momento — as tarefas ficam travadas até repor.
              </p>
            )}
            <ul className="mt-3 max-h-[50vh] space-y-2 overflow-y-auto pr-1">
              {day.tasks.map((t) => {
                const pct = Math.min(100, Math.round((t.progress / t.count) * 100));
                const off = !day.tasks_active && !t.done;
                return (
                  <li key={t.task_id} data-testid={`rp-task-${t.task_id}`} data-done={t.done}
                    className={`rounded-2xl border px-3 py-2.5 ${t.done ? 'border-lime-400/70 bg-lime-500/10' : off ? 'border-zinc-600/40 bg-zinc-800/40 grayscale' : 'border-fuchsia-400/40 bg-white/5'}`}>
                    <div className="flex items-center justify-between gap-2">
                      <span className="text-sm font-bold text-purple-50">Recarregue <b className="text-amber-300">{t.count}</b> pacotes de <b className="text-amber-300">{k(t.package_coins)}</b></span>
                      <span className={`flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-black ${t.done ? 'bg-lime-400 text-black' : 'bg-fuchsia-500/30 text-fuchsia-100'}`}>
                        {t.done ? <><CheckCircle2 className="h-3.5 w-3.5" /> +{t.reward_chests} baú ganho</> : <><img src="/rp/chest.webp" alt="" className="h-4 w-4 object-contain" /> +{t.reward_chests} baú extra</>}
                      </span>
                    </div>
                    <div className="mt-1.5 flex items-center gap-2">
                      <div className="h-2 flex-1 overflow-hidden rounded-full bg-white/10"><div className={`h-full transition-[width] duration-700 ${t.done ? 'bg-lime-400' : 'bg-gradient-to-r from-lime-400 to-fuchsia-400'}`} style={{ width: `${pct}%` }} /></div>
                      <span className="text-[11px] font-black tabular-nums text-purple-100" data-testid={`rp-task-progress-${t.task_id}`}>{t.progress}/{t.count}</span>
                    </div>
                  </li>
                );
              })}
            </ul>
            <p className="mt-3 text-center text-[10px] text-purple-200/60">Hoje você já recarregou 🪙{fmt(day.coins_day)} · {day.chests_day}/{day.max_per_day} baús por recarga</p>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default RpTasksButton;
